/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let siteUrl = ''
let baseUrl = ''
let routerMode = 'history'
let imgBaseUrl = ''
let imageUrl = ''
let productdata = [
  // {
  //   text: '本人個性',
  //   value: '1'
  // }, {
  //   text: '個人流年',
  //   value: '2'
  // },
  {
    text: '電話分析',
    value: '3'
  }, {
    text: '總體運勢',
    value: '4'
  }, {
    text: '客戶比對',
    value: '5'
  }, {
    text: '情侶夫妻比對',
    value: '6'
  }, {
    text: '親友雙方比對',
    value: '7'
  },
  {
    text: '職場比對',
    value: '8'
  }, {
    text: '高手過招',
    value: '9'
  }
];
let paymenttype= [
  {
    value: 0,
    text: 'APP內付款'
  },
  {
    value: 1,
    text: '補點紀錄'
  },
  {
    value: 2,
    text: '優惠紀錄'
  }
];

let paymentWebtype= [
  {
    value: 0,
    text: '付費訂單'
  },
  {
    value: 1,
    text: '優惠贈點'
  },
];


if (process.env.NODE_ENV == 'development') {
  siteUrl= 'https://192.168.0.100:8081'
  imageUrl = 'https://dev-api.name-q.com'
  baseUrl = 'https://dev-api.name-q.com/api/'
  // baseUrl = 'https://api.name-q.com/api/'
  // imageUrl = 'https://api.name-q.com'


} else if (process.env.NODE_ENV == 'production') {
  siteUrl= 'https://app.name-q.com'
  imageUrl = 'https://api.name-q.com'
  // baseUrl = 'https://api.name-app.me/api/'
  baseUrl = 'https://api.name-q.com/api/'

}
export {
  siteUrl,
  imageUrl,
  baseUrl,
  routerMode,
  imgBaseUrl,
  productdata,
  paymenttype,
  paymentWebtype,

}
